import React from "react"
import CustomRadioButton from "../../../../../ui/atoms/RadioButton"
import Typography from "../../../../../ui/atoms/Typography"
import classes from "./SamplesBox.module.css"

export interface ProductSample {
  id: string
  name: string
}

interface Props {
  samples: ProductSample[]
  selectedSamples: string[]
  toggleSample: (sampleId: string) => void
}

const SamplesBox = ({ samples, selectedSamples, toggleSample }: Props) => {
  return (
    <div>
      <Typography variant="subtitle1">Scegli i tuoi omaggi</Typography>
      {samples.map((x) => (
        <div key={x.id} className="my-2">
          <CustomRadioButton
            value={selectedSamples.includes(x.id)}
            onChange={() => toggleSample(x.id)}
            classes={{ label: classes.label }}
          >
            {x.name}
          </CustomRadioButton>
        </div>
      ))}
    </div>
  )
}

export default SamplesBox
